// extracted by mini-css-extract-plugin
module.exports = {"regular":"MessageLimit_regular__pyPkt","compact":"MessageLimit_compact__9DTeR","show":"MessageLimit_show__oE_BI"};